import { useEffect, useRef, useState } from "react";
import { Player } from "@lordicon/react/dist/player.js";

import "../styles/BubbleEffect.css";

function BubbleEffect({ isActive, setActiveSection, label, icon }) {
  const playerRef = useRef(null);
  const [iconSize, setIconSize] = useState(36); // Default size

  useEffect(() => {
    // Function to update icon size based on window width
    const updateSize = () => {
      if (window.innerWidth >= 1200) {
        setIconSize(56); // Large screens
      } else if (window.innerWidth >= 768) {
        setIconSize(48); // Medium screens
      } else {
        setIconSize(36); // Small screens
      }
    };

    // Initial size setting
    updateSize();

    // Add event listener to update size on window resize
    window.addEventListener("resize", updateSize);

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener("resize", updateSize);
    };
  }, []);

  useEffect(() => {
    if (playerRef) {
      playerRef.current?.playFromBeginning();
    }
  }, []);

  return (
    <div
      className="flex flex-col justify-around items-center relative"
      // onClick={() => setActiveSection(label)}
    >
      <div>
        <label className="flex items-center justify-center relative wrapper bubb">
          <input
            className={`bubble ${isActive ? "active-section" : ""}`}
            type="checkbox"
            name="dummy"
            value="on"
          />
          <div
            className={`top-20 max-w-fit opacity-100
                          h-auto p-1 rounded-lg absolute z-10 shadow-md flex justify-around items-center
                          ${isActive ? "text-green-700" : ""}`}
          ></div>

          <div className="lord-icon flex absolute 3xl:top-1 3xl:left-1 4xl:top-1 4xl:left-1">
            <Player
              ref={playerRef}
              icon={icon}
              size={iconSize}
              onComplete={() => playerRef.current?.playFromBeginning()}
            />
          </div>
        </label>
      </div>
    </div>
  );
}

export default BubbleEffect;
